import * as React from 'react';
import { MijnFNVMenu } from '../widgets/MijnFNVMenu';
import { PageHelpers } from './helpers/PageHelpers';
import { QRCodeContainer } from '../../containers/QRCodeContainer';
import { PageProps } from './interfaces/PageInterfaces';
import { DigitaleLedenpasLidnummerNaamContainer } from '../../containers/DigitaleLedenpasLidnummerNaamContainer';
import { MenuHelpers } from './helpers/MenuHelpers';
import { MijnFNVPageContext } from '../pages/helpers/MijnFNVPageContext';
import { getResourceString } from '../../kentico/resource-strings';


export class DigitaleLedenpasPage extends React.Component<PageProps> {
    
    render() { 
        MenuHelpers.showBreadCrumbs();
        MenuHelpers.showMenu();

        let print = (e) => {
            e.preventDefault();
            (window as any).print();
            return false;
        };

        return <React.Fragment>
            <div className="row  mijn-fnv__digitaleledenpas-page">
                <div className="col-12 col-md-1" />
                <div className="mijn-fnv__sidemenu col-12 col-md-2">
                    {MijnFNVMenu(PageHelpers.getSideMenu(this.props.kenticoPage), this.context.pathname)}
                </div>
                <div className="mijn-fnv__mainBlock col-12 col-md-8">
                    
                    <div className="row">
                        <div className="col-12 col-md-6 digitaleledenpas__content">
                            <h2>{this.props.kenticoPage.MijnFnvOverzicht.Alias}</h2>
                            <p>{this.props.kenticoPage.MijnFnvOverzicht.TaskIntroText}</p>
                        </div>
                        <div className="col-12 col-md-6 digitaleledenpas__pas">
                            <div className="digitaleledenpas">
                                <div className="digitaleledenpas__info-wrapper">
                                    <div className="digitaleledenpas__title-wrapper">
                                        <h3 className="digitaleledenpas__title">{getResourceString("Memberpass.Members.Text")}
                                            <span className="digitaleledenpas__highlight">{getResourceString("Memberpass.Pass.Text")}</span>
                                        </h3>
                                        <img src="/assets/img/layout/logo.svg" alt="" />
                                    </div>
                                    <DigitaleLedenpasLidnummerNaamContainer roles={[]}></DigitaleLedenpasLidnummerNaamContainer>
                                </div>
                                <QRCodeContainer></QRCodeContainer>                            
                            </div>
                            <a href="#" onClick={print} className="digitaleledenpas__printledenpas">{getResourceString("Memberpass.Print.Text")}</a>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-1"></div>
            </div>
        </React.Fragment>;
    }
}

DigitaleLedenpasPage.contextType = MijnFNVPageContext;